import React, { createContext, useReducer } from "react";

export const GeolocationContext = createContext([]);

const initialState = {
    userBounds: {},
    userAddress: "",
    searchedLocation: "",
    countryName: null,
    bounds: {},
    geolocationErrorMessage: "",
    isLoading: true
};

export const GeolocationContextProvider = props => {
    const [geolocationState, dispatchToGeolocation] = useReducer((state, action) => {
        switch (action.type) {
            case 'SET_SEARCHED_LOCATION':
                return {
                    ...state,
                    searchedLocation: action.payload.searchedLocation
                };
            case 'SET_COUNTRY_NAME':
                return {
                    ...state,
                    countryName: action.payload.countryName,
                    isLoading: action.payload.isLoading
                }; 
            case 'SET_IS_LOADING':
                return {
                    ...state,
                    isLoading: action.payload
                }; 
            case 'SET_MAP_BOUNDS': 
                return {
                    ...state,
                    bounds: action.payload.bounds
                };
            case 'SET_USER_LOCATION': 
                return {
                    ...state,
                    userBounds: action.payload.userBounds,
                    userAddress: action.payload.userAddress
                };
            case 'SET_GEOLOCATION_ERROR_MESSAGE':
                return {
                    ...state,
                    geolocationErrorMessage: action.payload.geolocationErrorMessage
                }
            default:
                throw new Error();
        };
    }, initialState);

    return (
        <GeolocationContext.Provider value={[geolocationState, dispatchToGeolocation]}>
            {props.children}
        </GeolocationContext.Provider>
    );
};
